export var ModalCssClass;
(function (ModalCssClass) {
    ModalCssClass["Base"] = "iress-modal";
    ModalCssClass["Show"] = "iress-modal--show";
    ModalCssClass["FixedFooter"] = "iress-modal--fixed-footer";
    ModalCssClass["Size"] = "iress-modal--size";
    ModalCssClass["Wrapper"] = "iress-modal__wrapper";
    ModalCssClass["CloseButton"] = "iress-modal__close";
    ModalCssClass["Content"] = "iress-modal__content";
    ModalCssClass["Footer"] = "iress-modal__footer";
    ModalCssClass["FooterHidden"] = "iress-modal__footer--hidden";
    ModalCssClass["Backdrop"] = "iress-modal__backdrop";
})(ModalCssClass || (ModalCssClass = {}));
export var ModalSlot;
(function (ModalSlot) {
    ModalSlot["Footer"] = "footer";
})(ModalSlot || (ModalSlot = {}));
export var ModalSize;
(function (ModalSize) {
    ModalSize["Sm"] = "sm";
    ModalSize["Md"] = "md";
    ModalSize["Lg"] = "lg";
    ModalSize["FullPage"] = "fullpage";
})(ModalSize || (ModalSize = {}));
//# sourceMappingURL=modal.types.js.map